<script>
    import { createEventDispatcher } from 'svelte'
    import { Label } from 'sveltestrap'
    import ChromePicker from 'svelte-color/Chrome.svelte'
    import Required from './Required.svelte'

    export let context
    export let formKey
    export let keypath
    export let label
    export let required
    export let value = '#000000'

    $: formKeypath = `${formKey}.${keypath}`

    const dispatch = createEventDispatcher()
    function update(event) {
        value = event.detail[0] === '#' ? event.detail.split('#')[1] : event.detail

        dispatch('change', { formKey, keypath, value, context })
    }
</script>

<div class="component-form-field component-form-field-color">
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>

    <ChromePicker
        class="classes to add to the root element"
        bind:value
        disableAlpha={true}
        on:input={update}
        startColor={value}
    />
</div>
